/* Armadio di Sofia · «vola al carrello» (22 oct 2026)
   Al pulsar «Aggiungi al carrello», la foto del producto se encoge y vuela hasta el icono del carrito,
   que da un saltito; el carrito lateral se pinta y se abre al aterrizar.
   Solo visual: no toca cómo se añade al carrito. Para quitarlo, borrar este archivo y su <script> en layout/theme.liquid. */
(function () {
  if (window.__clVolo) return;
  window.__clVolo = true;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var volo = null; // promesa del vuelo en curso

  function clamp(v, a, b) { return Math.max(a, Math.min(b, v)); }
  function lerp(a, b, t) { return a + (b - a) * t; }
  function easeOut(t) { return 1 - Math.pow(1 - t, 3); }
  function outQuad(t) { return 1 - (1 - t) * (1 - t); }
  function inQuad(t) { return t * t; }
  function suave(t) { return t * t * (3 - 2 * t); }

  function fraccionVisible(r) {
    if (!r.width || !r.height) return 0;
    var w = Math.max(0, Math.min(r.right, innerWidth) - Math.max(r.left, 0));
    var h = Math.max(0, Math.min(r.bottom, innerHeight) - Math.max(r.top, 0));
    return (w * h) / (r.width * r.height);
  }

  function fotoDe(form) {
    var zona = form.closest('quick-add-modal, .shopify-section, .product') || document;
    return zona.querySelector('.product__media-item.is-active img') ||
      zona.querySelector('.product__media-item img, .product__media img, .card__media img');
  }

  // La cabecera se esconde al bajar (sticky «on-scroll-up»): se enseña para que se vea el carrito.
  function mostrarCabecera() {
    var sec = document.querySelector('.section-header');
    var sh = document.querySelector('sticky-header');
    if (sec && sec.classList.contains('shopify-section-header-hidden') && sh && typeof sh.reveal === 'function') sh.reveal();
  }

  // Desde dónde sale si la foto no se ve: el botón pulsado o, si está fuera de pantalla, el de la barra fija.
  function anclaBoton(boton) {
    var r = boton.getBoundingClientRect();
    if (fraccionVisible(r) > 0.5) return r;
    var b = document.querySelector('.cl-barra.is-visible .cl-barra__btn');
    if (b) return b.getBoundingClientRect();
    return { left: innerWidth / 2 - 40, top: innerHeight - 110, width: 80, height: 40 };
  }

  function destino() {
    var el = document.getElementById('cart-icon-bubble');
    var r = el && el.getBoundingClientRect();
    if (!r || r.bottom <= 0 || r.top >= innerHeight || !r.width) return { x: innerWidth - 32, y: 28 };
    return { x: r.left + r.width / 2, y: r.top + r.height / 2 };
  }

  function saltito() {
    var el = document.getElementById('cart-icon-bubble');
    if (!el || !el.animate) return;
    el.animate(
      [{ transform: 'scale(1)' }, { transform: 'scale(1.3)' }, { transform: 'scale(0.9)' }, { transform: 'scale(1.06)' }, { transform: 'scale(1)' }],
      { duration: 520, easing: 'ease-out' }
    );
    var c = destino();
    var aro = document.createElement('div');
    aro.setAttribute('aria-hidden', 'true');
    aro.style.cssText = 'position:fixed;left:' + (c.x - 22) + 'px;top:' + (c.y - 22) + 'px;width:44px;height:44px;border-radius:50%;' +
      'border:2px solid rgba(58,51,44,.45);pointer-events:none;z-index:2147483000;';
    document.body.appendChild(aro);
    var a = aro.animate([{ transform: 'scale(.4)', opacity: 0.9 }, { transform: 'scale(1.7)', opacity: 0 }], { duration: 560, easing: 'ease-out' });
    a.onfinish = function () { aro.remove(); };
  }

  function volar(form, boton) {
    var img = fotoDe(form);
    var src = img && (img.currentSrc || img.src);
    if (!src) return null;

    mostrarCabecera();

    var ri = img.getBoundingClientRect();
    var deFoto = fraccionVisible(ri) >= 0.35;
    var rb = anclaBoton(boton);
    var lado = 92;
    var caja = deFoto
      ? { x: ri.left, y: ri.top, w: ri.width, h: ri.height }
      : { x: rb.left + rb.width / 2 - lado / 2, y: rb.top - lado - 8, w: lado, h: lado };

    var fly = document.createElement('img');
    fly.src = src;
    fly.alt = '';
    fly.setAttribute('aria-hidden', 'true');
    fly.style.cssText = 'position:fixed;left:' + caja.x + 'px;top:' + caja.y + 'px;width:' + caja.w + 'px;height:' + caja.h + 'px;' +
      'object-fit:cover;margin:0;max-width:none;pointer-events:none;z-index:2147483001;will-change:transform,opacity;' +
      'transform-origin:50% 50%;border-radius:' + (deFoto ? 0 : 10) + 'px;box-shadow:0 10px 26px rgba(46,41,37,.18);';
    document.body.appendChild(fly);

    var x0 = caja.x + caja.w / 2, y0 = caja.y + caja.h / 2;
    var d0 = destino();
    var dist = Math.hypot(d0.x - x0, d0.y - y0);
    var dur = clamp(620 + dist * 0.35, 700, 1000);
    var sFin = 30 / Math.max(caja.w, caja.h);
    var t0 = null;

    return new Promise(function (resolve) {
      var hecho = false;
      function fin() {
        if (hecho) return;
        hecho = true;
        fly.remove();
        saltito();
        setTimeout(resolve, 260); // que se vea el saltito antes de abrir el carrito
      }
      function paso(t) {
        if (t0 === null) t0 = t;
        var p = clamp((t - t0) / dur, 0, 1);
        var d = destino(); // se mide en cada fotograma: la cabecera puede estar entrando
        var x = lerp(x0, d.x, outQuad(p));
        var y = lerp(y0, d.y, inQuad(p)); // x rápida e y lenta al principio: curva
        var s = deFoto
          ? (p < 0.12 ? lerp(1, 1.04, p / 0.12) : lerp(1.04, sFin, easeOut((p - 0.12) / 0.88)))
          : (p < 0.15 ? lerp(0.55, 1, easeOut(p / 0.15)) : lerp(1, sFin, suave((p - 0.15) / 0.85)));
        var op = p < 0.82 ? 1 : lerp(1, 0.2, (p - 0.82) / 0.18);
        fly.style.transform = 'translate(' + (x - x0) + 'px,' + (y - y0) + 'px) scale(' + s + ')';
        fly.style.opacity = op;
        // Esquinas igual de suaves mientras encoge (tarjetita de foto, sin pasar a círculo).
        var radio = deFoto ? lerp(0, 7, outQuad(p)) : lerp(10, 7, p);
        fly.style.borderRadius = (radio / s) + 'px';
        if (p < 1) requestAnimationFrame(paso); else fin();
      }
      requestAnimationFrame(paso);
      setTimeout(fin, dur + 800); // por si la pestaña está en segundo plano
    });
  }

  // Al pulsar el botón (antes que el propio formulario del tema).
  document.addEventListener('submit', function (e) {
    if (reduce || volo || !document.querySelector('cart-drawer')) return;
    var pf = e.target && e.target.closest && e.target.closest('product-form');
    if (!pf) return;
    var boton = pf.querySelector('[type="submit"]');
    if (!boton || boton.disabled || boton.getAttribute('aria-disabled') === 'true') return;
    var p = volar(pf, boton);
    if (!p) return;
    volo = p.then(function () { volo = null; });
  }, true);

  // El carrito lateral espera a que aterrice la foto para pintarse y abrirse.
  if (window.customElements) {
    customElements.whenDefined('cart-drawer').then(function () {
      var C = customElements.get('cart-drawer');
      if (!C || C.prototype.__clVolo) return;
      var pintar = C.prototype.renderContents;
      C.prototype.renderContents = function (state) {
        var self = this;
        if (volo) { volo.then(function () { pintar.call(self, state); }); return; }
        return pintar.call(this, state);
      };
      C.prototype.__clVolo = true;
    });
  }
})();
